import { StyleSheet } from "../../react-native-components";

const styles = StyleSheet.create({
    pieChartContainer: {
        padding: 20,
        width: 160,
        textAlign: 'center',
        backgroundColor: 'black',
        borderRadius: 10,
        alignItems: 'center'
    },
    tooltipLabel: {
        textAlign: 'center'
    },
    tooltipValue: {
        marginBottom: 10
    }
})
export default styles